import { useState, useEffect } from 'react';
import { horodatyApi } from '@/lib/utils/horodaty-api';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormCollaboratorEdit, { FORM_COLLABORATOR_EDIT_ID } from '../forms/FormCollaboratorEdit';
import { useTranslation } from 'react-i18next';

export default function SheetCollaboratorEdit({
    open,
    onClose,
    collaborator,
    onSubmit,
    resetKey,
    isSubmitting = false,
}) {
    const { t } = useTranslation();

    const [roles, setRoles] = useState([]);

    useEffect(() => {
        if (open) {
            horodatyApi
                .managerGetAvailableRoles()
                .then((response) => {
                    setRoles(response.data.data);
                })
                .catch((error) => {
                    console.error('Erreur lors de la récupération des rôles', error);
                });
        }
    }, [open]);


    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] md:w-[500px]! md:max-w[500px]! flex flex-col p-0">
                <SheetHeader className="px-6 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{t('account:modifierLeCollaborateur')}</SheetTitle>
                </SheetHeader>

                <FormCollaboratorEdit key={resetKey} collaborator={collaborator} onSubmit={onSubmit} roles={roles} />

                <SheetFooter className="px-6 py-4 border-t border-border flex items-center justify-between gap-3">
                    <Button
                        type="button"
                        variant="soft"
                        color="neutral"
                        className="px-4 py-3 rounded-lg"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        {t('account:annuler')}
                    </Button>
                    <SubmitButton
                        form={FORM_COLLABORATOR_EDIT_ID}
                        className="px-6 py-3 rounded-lg"
                        isSubmitting={isSubmitting}
                        loadingText={t('account:enregistrement')}
                    >
                        {t('account:enregistrer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
